const actionTypes = require('constants/actionTypes');
const { Promise } = require('es6-promise');
const { APIPost } = require('utilities/APIRequestHelper');
const signaturePatternActions = require('actions/signaturePattern');

const resetPin = cardId => ({
    type: actionTypes.CARDS_PIN_RESET,
    payload: {
        cardId
    }
});

const setExpired = cardId => ({
    type: actionTypes.SET_CARDS_PIN_EXPIRED,
    payload: {
        cardId
    }
});

const requestCardsPin = cardId => ({
    type: actionTypes.FETCH_CARDS_PIN_REQUEST,
    payload: {
        cardId
    }
});

const requestCardsPinSuccess = (data, cardId) => ({
    type: actionTypes.FETCH_CARDS_PIN_SUCCESS,
    payload: {
        cardId,
        code: data.pin
    }
});

const requestCardsPinFailure = (error, cardId) => ({
    type: actionTypes.FETCH_CARDS_PIN_FAILURE,
    payload: {
        cardId,
        error
    }
});

const requestPin = cardId => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCard = getState().cards.get('byId').get(cardId);
        const numTarjeta = immCard.get('number');
        const product = immCard.get('contract').get('product');
        const contractNumber = immCard.get('contract').get('number');

        const requestData = {
            query: {
                dataToken,
                numTarjeta,
                entradaSeg: {
                    contrato: {
                        producto: product,
                        numerodecontrato: contractNumber
                    }
                }
            }
        };

        dispatch(requestCardsPin(cardId));
        APIPost({ dispatch, endpoint: 'cardPinRequest', params: requestData })
            .then(response => dispatch(requestCardsPinSuccess(response, cardId)))
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestCardsPinFailure(response.error, cardId));
                } else {
                    throw response;
                }
            });
    };

    new Promise(function() {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

module.exports = {
    requestPin,
    resetPin,
    setExpired
};
